import { useEffect } from "react";

function useWindowResize(callback: () => void) {
  useEffect(() => {
    let timeout;
    window.addEventListener("resize", onResize);
    callback();

    return () => {
      timeout && clearTimeout(timeout);
      window.removeEventListener("resize", onResize);
    };

    function onResize() {
      // console.log("【call】onResize");
      if (timeout) return;
      timeout = setTimeout(() => {
        timeout = null;
        callback();
      }, 100);
    }
  }, []);
}

export default useWindowResize;
